export class Riesgo {

    riesgo: String;
    codigoTipoRiesgo: String;
    codigoTipoCausal: String;
    codigoRamo: String;
    codigoSubramo: String;
    codigoFigura: String;
    codigoOperacion: String;
    codigoSubOperacion: String;

    constructor() { }
}



// WEBPACK FOOTER //
// ./src/app/models/cliente/riesgo.class.ts